import './AccountForm.less';
import React, {useState, useEffect, useRef} from 'react';
import __ from "../../../i18n";
import CustomForm from "../../../../bootstrap/components/custom-form/CustomForm";
import Request from "../../../../bootstrap/api/Request";
import AuthRegisterParcel from "../../../api/endpoints/auth/AuthRegisterParcel";
import Toasts, {TOAST_SUCCESS} from "../../../../bootstrap/scomponents/toasts/Toasts";


export default function AccountForm({onDone}) {

    const fieldsConfig = {
        full_name: {
            name: __('Full name'),
            type: 'text',
            rules: {
                required: true,
                minLength: 3
            },
            options: {
                appearance: 'box',
                prompt: __('Enter your full name')
            }
        },
        email: {
            name: __('Email'),
            type: 'text',
            rules: {
                required: true,
                match: 'email'
            },
            options: {
                appearance: 'box',
                prompt: __('email@example.com')
            }
        },
        phone: {
            name: __('Phone number'),
            type: 'text',
            rules: {
                required: true,
                match: 'vietnamese_phone'
            },
            options: {
                appearance: 'box',
                prompt: __('Your mobile phone number')
            }
        },
        password: {
            name: __('Password'),
            type: 'text',
            rules: {
                required: true,
                minLength: {
                    value: 6,
                    error: __('Password must contain at least ::minLength characters', {minLength: 6})
                }
            },
            options: {
                style: 'password',
                passwordCanShow: true,
                appearance: 'box',
                prompt: __('New password'),
            }
        },
    };

    const layoutConfig = [
        'full_name',
        'email',
        'phone',
        'password',
    ];

    const handleSubmit = (values, onSuccess, onError) => {
        Request.add(new AuthRegisterParcel(values))
            .then(info => {
                onSuccess();
                onDone(info);
                Toasts.add(TOAST_SUCCESS, __('Your account has been created successfully'));
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    return <div className="account-form">
        <CustomForm
            fieldsConfig={fieldsConfig}
            layoutConfig={layoutConfig}
            submit={handleSubmit}
            submitText={__('Create account')}
            allowsSubmit={(hasChanges, values, errors) => Object.keys(errors).length === 0}
        />
    </div>;
}
